import { render, staticRenderFns } from "./AcceptProductSharePage.vue?vue&type=template&id=403515d0"
import script from "./AcceptProductSharePage.vue?vue&type=script&lang=js"
export * from "./AcceptProductSharePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports